import { render, staticRenderFns } from "./AudienceSchemaBlockCard.vue?vue&type=template&id=59d28ebe&scoped=true"
import script from "./AudienceSchemaBlockCard.vue?vue&type=script&lang=ts"
export * from "./AudienceSchemaBlockCard.vue?vue&type=script&lang=ts"
import style0 from "./AudienceSchemaBlockCard.vue?vue&type=style&index=0&id=59d28ebe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d28ebe",
  null
  
)

export default component.exports